export class QuotationStatusDTO {
    appStatTypcodeId :{
        portfolioId: number,
        statusId: number
    };
    statusId : number;
    statusDesc: string="";
    nextStatusDesc: string;
}
